module.exports = __webpack_public_path__ + "static/media/ProximaNovaAltLight.e2602b2f.otf";